import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-left-side-navigation',
  templateUrl: './left-side-navigation.component.html',
  styleUrls: ['./left-side-navigation.component.scss'],
  imports: [CommonModule],
})
export class LeftSideNavigationComponent implements OnInit {
  pageIndex = 0;
  environment = environment;

  pages: string[] = [];

  constructor(private appService: AppService, private router: Router) {
    this.pages = this.appService.pages;
  }

  ngOnInit(): void {
    this.appService.getPageIndex().subscribe({
      next: (pageIndex: number) => {
        this.pageIndex = pageIndex;
      },
      error: (error) => {
        console.error('Error getting pageIndex:', error);
      },
    });
  }

  handleKeyDown(event: KeyboardEvent, index: number) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.setPageIndex(index);
    }
  }

  setPageIndex(index: number): void {
    this.appService.setPageIndex(index);
  }

  onCommentClick(): void {
    this.router.navigate(['/public-comment']);
  }
}
